module.exports = __webpack_public_path__ + "img/trip_sendai02.b13f02ec.jpg";